import { BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
var DwActionAuthorizedService = /** @class */ (function () {
    function DwActionAuthorizedService() {
    }
    /**
     * 設定功能權限資料
     *
     * @param dwAuthorizedId 作業權限ID
     * @param dwActionId 功能按鈕ID
     */
    DwActionAuthorizedService.prototype.setActionAuth = function (dwAuthorizedId, dwActionId) {
        this.restriction = null;
        this.actionAuthorizedSubject = new BehaviorSubject(this.restriction);
        this.restriction = 'allow';
        this.actionAuthorizedSubject.next(this.restriction);
    };
    Object.defineProperty(DwActionAuthorizedService.prototype, "actionAuthorizedSubject$", {
        /**
         * 提供訂閱功能權限資料
         */
        get: function () {
            return this.actionAuthorizedSubject.asObservable().pipe(filter(function (obsData) { return obsData !== null; }), // 不廣播初始值
            distinctUntilChanged() // 有改變時才廣播
            );
        },
        enumerable: true,
        configurable: true
    });
    return DwActionAuthorizedService;
}());
export { DwActionAuthorizedService };
